import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Snackbar } from '@mui/material';
import { createContext, useContext, useState } from 'react';
const AlertDefaults = {
    showAlert: () => { },
};
const AlertContext = createContext(AlertDefaults);
export const useAlert = () => {
    const ctx = useContext(AlertContext);
    if (!ctx) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return ctx;
};
/**
 * AlertProvider component provides a context for displaying alerts.
 * It allows showing alerts with different severity levels.
 */
export const AlertProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    /**
     * Shows an alert with the specified message and severity.
     * @param message - The message to be displayed in the alert.
     * @param severity - The severity level of the alert. Defaults to 'success'.
     */
    const showAlert = (message, severity = 'success') => {
        setOpen(true);
        setMessage(message);
        setSeverity(severity);
    };
    return (_jsxs(AlertContext.Provider, { value: { showAlert }, children: [children, _jsx(Snackbar, { open: open, onClose: () => setOpen(false), autoHideDuration: 6000, anchorOrigin: { vertical: 'top', horizontal: 'center' }, children: _jsx(Alert, { severity: severity, children: message }) })] }));
};
